import { render, staticRenderFns } from "./DocumentarySettlements.vue?vue&type=template&id=4f73de08"
import script from "./DocumentarySettlements.vue?vue&type=script&lang=js"
export * from "./DocumentarySettlements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports